import { Users, LifeBuoy, Lock as LockIcon } from 'lucide-react';
import { useSupport } from '../../../../context/support/SupportContext';
import { supportData } from '../../utils/supportHelpers';
import PlanGate from '../../../../components/gating/PlanGate';

const SupportHeader = () => {
  const { currentTab, setSearchParams, totalUnreadTravellerCount } = useSupport();

  return (
    <div className="mb-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
      <div>
        <h1 className="text-xl sm:text-2xl font-black text-[#067978] tracking-tight uppercase">
          {supportData.header.title}
        </h1>
        <p className="text-xs sm:text-sm text-slate-500 mt-1">
          {supportData.header.description}
        </p>
      </div>

      {/* Top Segmented Workspace Tabs */}
      <div className="flex bg-gray-100/80 p-1 rounded-2xl border border-gray-200 shadow-inner w-full md:w-auto">
        <PlanGate
          requiredPlan="starter"
          featureName="In-App Traveller Chat"
          tooltipText="In-App Traveller Chat requires an active subscription."
          showLockIcon={false}
          wrapperClassName="flex-1 md:flex-none"
        >
          {({ isLocked }) => (
            <button
              type="button"
              onClick={() => setSearchParams({ tab: 'travellers' })}
              className={`w-full flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl text-xs sm:text-sm font-bold transition-all cursor-pointer ${
                currentTab === 'travellers'
                  ? 'bg-[#067978] text-white shadow-md shadow-teal-900/20'
                  : 'text-gray-600 hover:text-[#067978]'
              }`}
            >
              <Users size={16} />
              <span>{supportData.tabs.travellers.label}</span>
              {isLocked && (
                <LockIcon
                  size={14}
                  className={`ml-1 ${
                    currentTab === 'travellers' ? 'text-white' : 'text-[#067978]'
                  } shrink-0`}
                />
              )}
              {totalUnreadTravellerCount > 0 && !isLocked && (
                <span
                  className={`ml-1 w-5 h-5 flex items-center justify-center rounded-full text-[10px] font-black ${
                    currentTab === 'travellers'
                      ? 'bg-white text-[#067978]'
                      : 'bg-[#067978] text-white'
                  }`}
                >
                  {totalUnreadTravellerCount}
                </span>
              )}
            </button>
          )}
        </PlanGate>

        <button
          onClick={() => setSearchParams({ tab: 'helpdesk' })}
          className={`flex-1 md:flex-none flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl text-xs sm:text-sm font-bold transition-all cursor-pointer ${
            currentTab === 'helpdesk'
              ? 'bg-[#067978] text-white shadow-md shadow-teal-900/20'
              : 'text-gray-600 hover:text-[#067978]'
          }`}
        >
          <LifeBuoy size={16} />
          <span>{supportData.tabs.helpdesk.label}</span>
        </button>
      </div>
    </div>
  );
};

export default SupportHeader;
